import { create } from 'zustand';
import { ZustandUserActions, ZustandUserIds } from './types';

interface UserStore extends ZustandUserIds, ZustandUserActions {}

const useUserStore = create<UserStore>((set) => ({
  userId: '',
  quizId: '',
  userEmail: '',
  userCountry: '',
  recommendedCourseId: '',
  setUserCountry: (userCountry) => set({ userCountry }),
  setUserId: (userId) => set({ userId }),
  setQuizId: (quizId) => set({ quizId }),
  setUserEmail: (userEmail) => set({ userEmail }),
  setRecommendedCourseId: (recommendedCourseId) => set({ recommendedCourseId }),
}));

export default useUserStore;
